import { useDeleteTimesheets } from '@sit/openapi';
import { useIsStaff, useTimesheetModalActions } from '../hooks';
import { DeleteTimesheetsModal } from './DeleteTimesheetsModal';
import { TimesheetBulkDeleteItem } from './TimesheetModalContext';

const useBulkDeleteModal = (timesheets: TimesheetBulkDeleteItem[] | undefined) => {
  const { closeModal } = useTimesheetModalActions();
  const { mutate: bulkDelete } = useDeleteTimesheets();
  const staff = useIsStaff();

  const deleteTimesheets = () => {
    if (!timesheets) return;
    bulkDelete({
      queryParams: {
        staff: staff ? 'true' : 'false',
      },
      body: {
        id: timesheets?.map((t) => t.id),
      },
    });
  };

  return {
    timesheets,
    onClose: closeModal,
    onOk: deleteTimesheets,
  };
};

interface DuplicateTimesheetProps {
  timesheets: TimesheetBulkDeleteItem[] | undefined;
  open: boolean;
}

export const BulkDeleteTimesheets = ({ timesheets, open }: DuplicateTimesheetProps) => {
  const modalProps = useBulkDeleteModal(timesheets);

  return <DeleteTimesheetsModal {...modalProps} open={open} />;
};
